import { NON_SELECTABLE_ROOT_STRATEGIC_INITIATIVES } from '../../../../lpKeyInitiatives/components/keyInitiativeEditorModal/configs'
import { IHierarchyKeyObjectives } from '../../../../lpKeyInitiatives/components/keyInitiativeEditorModal/models/hierarchyKeyObjectives'

type TKeyObjectiveSelectionItem = Pick<IHierarchyKeyObjectives, 'key' | 'parent' | 'HasChildren'>

export const isKeyObjectiveSelectable = (
  item: TKeyObjectiveSelectionItem,
  selectOnlyLeaves: boolean
): boolean => {
  if (selectOnlyLeaves) {
    return !item.HasChildren
  }

  if (item.parent) {
    return true
  }

  return !NON_SELECTABLE_ROOT_STRATEGIC_INITIATIVES.includes(item.key)
}
